import { FC } from 'react';

interface SkeletonWrapperProps {
  loading?: boolean;
  skeleton?: JSX.Element | JSX.Element[];
  children?: JSX.Element | JSX.Element[];
}

const SkeletonWrapper: FC<SkeletonWrapperProps> = ({
  loading = false,
  skeleton,
  children,
}) => <>{loading ? skeleton : children}</>;

export default SkeletonWrapper;
